import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import { DEFAULT_LANGUAGE, LANGUAGE_STORAGE_KEY } from '@/shared/constants/languages';
import { loadRemoteLabelBundle } from './remote-bundle';
import { resources } from './resources';

export const initI18n = async () => {
  if (!i18n.isInitialized) {
    await i18n
      .use(LanguageDetector)
      .use(initReactI18next)
      .init({
        resources,
        fallbackLng: DEFAULT_LANGUAGE,
        supportedLngs: ['en', 'ko'],
        defaultNS: 'common',
        ns: [
          'common',
          'auth',
          'admin',
          'medical',
          'roles',
          'validation',
          'management-guidelines',
          'counseling-manual',
          // Backend-served label catalog (status/brand/grade); fetched at runtime, not bundled.
          'labels',
        ],

        interpolation: {
          escapeValue: false,
        },

        // Language is chosen by the `?locale=ko|en` URL query first (a dev / QA toggle), then by
        // the last cached choice. There is deliberately NO `navigator` (browser-locale) leg: the
        // shipped app is Korean-only, so a non-Korean browser must still fall back to Korean
        // (`fallbackLng`) — English is opt-in via `?locale=en` only. The detected value is cached to
        // localStorage so it sticks across client-side navigation until `?locale=ko` (or cleared
        // storage) switches it back.
        detection: {
          order: ['querystring', 'localStorage'],
          lookupQuerystring: 'locale',
          lookupLocalStorage: LANGUAGE_STORAGE_KEY,
          caches: ['localStorage'],
        },

        react: {
          useSuspense: false,
        },
      });
  }

  // Keep <html lang> in sync with the resolved language (accessibility + lang-scoped CSS).
  if (typeof document !== 'undefined') {
    document.documentElement.lang = i18n.language;
  }

  // Fetch + register the backend-owned label catalog. Retryable: re-runs on each call (e.g. a gate retry)
  // without re-initializing i18next. Throws on failure so the loading gate can show a fallback.
  await loadRemoteLabelBundle();

  return i18n;
};

export default i18n;